// -----------------------------------------------------------
// FloraIQ - Interference3DTable — Aba Interferências 3D
// -----------------------------------------------------------

import { interferences3D } from "@/mocks/pointcloud";

const summaryCards = [
  { title: "Interferências críticas", value: 1, icon: "ri-error-warning-line", color: "danger", bgColor: "bg-red-100", textColor: "text-red-600" },
  { title: "Rede elétrica x copa", value: 3, icon: "ri-flashlight-line", color: "warning", bgColor: "bg-amber-100", textColor: "text-amber-600" },
  { title: "Copas sobre vias", value: 1, icon: "ri-road-map-line", color: "warning", bgColor: "bg-amber-100", textColor: "text-amber-600" },
  { title: "Próximas a edificações", value: 2, icon: "ri-building-line", color: "info", bgColor: "bg-blue-100", textColor: "text-blue-600" },
  { title: "Poda preventiva necessária", value: 7, icon: "ri-scissors-line", color: "warning", bgColor: "bg-amber-100", textColor: "text-amber-600" },
];

export default function Interference3DTable() {
  return (
    <div className="space-y-4">
      {/* Cards resumo */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {summaryCards.map((card) => (
          <div key={card.title} className="bg-white rounded-card border border-background-200/70 p-3">
            <div className="flex items-center gap-2.5">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${card.bgColor} ${card.textColor}`}>
                <i className={`${card.icon} text-sm`}></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-foreground-500 truncate">{card.title}</p>
                <p className="text-sm font-bold text-foreground-900 font-heading">{card.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tabela */}
      <div className="bg-white rounded-card border border-background-200/70 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/70 bg-background-50/50">
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Código CTA</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Espécie</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Tipo de Interferência</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Distância</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Intensidade</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Fonte 3D</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Recomendação</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Status</th>
                <th className="text-left px-3 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Ações</th>
              </tr>
            </thead>
            <tbody>
              {interferences3D.map((i) => {
                const intensidadeClass =
                  i.intensidade === "critica" ? "bg-red-100 text-red-700 border-red-200" :
                  i.intensidade === "alta" ? "bg-orange-50 text-orange-700 border-orange-200" :
                  i.intensidade === "media" ? "bg-amber-50 text-amber-700 border-amber-200" :
                  "bg-green-50 text-green-700 border-green-200";

                const statusClass =
                  i.status === "critico" ? "bg-red-100 text-red-700 border-red-200" :
                  i.status === "pendente" ? "bg-orange-50 text-orange-700 border-orange-200" :
                  i.status === "monitorando" ? "bg-blue-50 text-blue-700 border-blue-200" :
                  "bg-green-50 text-green-700 border-green-200";

                const statusLabel =
                  i.status === "critico" ? "Crítico" :
                  i.status === "pendente" ? "Pendente" :
                  i.status === "monitorando" ? "Monitorando" : "Resolvido";

                return (
                  <tr key={i.id} className="border-b border-background-100/50 hover:bg-background-50/30 transition-colors">
                    <td className="px-3 py-2 text-xs font-medium text-foreground-800 whitespace-nowrap font-mono">{i.codigoCta}</td>
                    <td className="px-3 py-2 text-xs text-foreground-600 whitespace-nowrap">{i.especie}</td>
                    <td className="px-3 py-2 text-xs text-foreground-700 whitespace-nowrap">{i.tipoInterferencia}</td>
                    <td className="px-3 py-2 text-xs text-foreground-600 whitespace-nowrap">{i.distancia} m</td>
                    <td className="px-3 py-2">
                      <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-medium rounded-full border whitespace-nowrap ${intensidadeClass}`}>
                        {i.intensidade.charAt(0).toUpperCase() + i.intensidade.slice(1)}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-xs text-foreground-500 whitespace-nowrap font-mono">{i.fonte3D}</td>
                    <td className="px-3 py-2 text-xs text-foreground-600 max-w-[200px] truncate">{i.recomendacao}</td>
                    <td className="px-3 py-2">
                      <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-medium rounded-full border whitespace-nowrap ${statusClass}`}>
                        {statusLabel}
                      </span>
                    </td>
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-1">
                        <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors cursor-pointer" title="Ver no 3D" aria-label="Ver no 3D">
                          <i className="ri-stack-line text-foreground-500 text-sm"></i>
                        </button>
                        <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors cursor-pointer" title="Ver FCA" aria-label="Ver FCA">
                          <i className="ri-plant-line text-foreground-500 text-sm"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}